
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/become-a-technician",
      function () {
        return require("private-next-pages/become-a-technician.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/become-a-technician"])
      });
    }
  